import "./App.css";
import { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { isMobile } from "react-device-detect";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Contact from "./pages/Contact";
import Leaderboard from "./pages/Leaderboard";
import WalletSuccess from "./pages/WalletSuccess";
import Dashboard from "./user/Dashboard";
import ProtectedRoute from "./components/ProtectedRoute";
import Terms from "./pages/Terms";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import RefundPolicy from "./pages/RefundPolicy";
import AdminLogin from "./admin/AdminLogin";
import PublicRoute from "./components/PublicRoute";
import ProductInfo from "./pages/ProductInfo";
import Loader from "./pages/Loader";
import Success from "./pages/Success";
import Failure from "./pages/Failure";
import PromoEvents from "./pages/PromoEvents";
import SinglePromoEvent from "./pages/SinglePromoEvent";
import TrackOrder from "./pages/TrackOrder";
import Orders from "./user/Orders";
import Account from "./user/Account";
import ViewOrder from "./user/ViewOrder";
import Wallet from "./user/Wallet";
import Query from "./user/Query";
import Maintenance from "./user/Maintenance";
import Announcement from "./user/Announcement";
import PaymentHistory from "./admin/PaymentHistory.js";
import Reports from "./admin/Reports.js";
// MOBILE
import MobileLogin from "./pages/MobileLoginRegisterEtc/MobileLogin";
import UserWallet from "./pages/UserWallet";
import PaymentStatus from "./pages/PaymentStatus";
import { useDispatch, useSelector } from "react-redux";
import { getUser } from "./services/user.service.js";
import { Navigate } from "react-router-dom";
import { userExist, userNotExist } from "./redux/features/userSlice.js";
import OrderStatus from "./pages/OrderStatus";

function App() {
	const { user, loading } = useSelector((state) => state.user);
	const dispatch = useDispatch();

	const fetchUser = async () => {
		try {
			const data = await getUser();
			const user = {
				_id: data._id,
				name: data.name,
				phone: data.phone,
				email: data.email,
				verified: data.verified,
				walletBalance: data.walletBalance,
				role: data.role,
				profilePicture: data.profilePicture,
				marketingConsent: data.marketingConsent
			}
			dispatch(userExist(user));
		} catch (error) {
			dispatch(userNotExist());
		}
	};

	useEffect(() => {
		fetchUser();
	}, []);

	// Link this visitor to their Brevo contact (on page load and after login)
	useEffect(() => {
		if (!user?.email) return;
		window.Brevo = window.Brevo || [];
		window.Brevo.push(["identify", { identifiers: { email_id: user.email } }]);
	}, [user?.email]);

	return (
		<BrowserRouter>
			{loading ? (
				<Loader />
			) : user  ? (
				<Routes>
					{/* pages */}
					<Route path="/:token?" element={<Home />} />
					{/* <Route
						path="/register"
						element={
						<PublicRoute>
							<Register />
						</PublicRoute>
						}
					/> */}
					{/* <Route
						path="/login"
						element={
							<PublicRoute>
								{isMobile ? <MobileLogin /> : <Login />}
							</PublicRoute>
						}
					/> */}
					<Route path="/login" element={user === null ? isMobile ? <MobileLogin /> : <Login /> : <Navigate to="/" />} />
					{/* <Route path="/forgot-password" element={<ForgotPass />} /> */}
					<Route path="/support" element={<Contact />} />
					<Route path="/leaderboard" element={<Leaderboard />} />
					<Route path="/walletsuccess" element={<WalletSuccess />} />
					<Route path="/payment-status" element={<PaymentStatus />} />
					<Route path="/track-order" element={<TrackOrder />} />
					<Route path="/product/:name?" element={<ProductInfo />} />
					<Route path="/promo/:id?" element={<SinglePromoEvent />} />
					<Route path="/promo" element={<PromoEvents />} />
					<Route path="/announcement" element={<Announcement />} />
					<Route path="/success" element={<Success />} />
					<Route path="/failure/:error?" element={<Failure />} />
					<Route path="/order-status" element={<OrderStatus />} />

					<Route
						element={loading ? (
							<Loader />
						) : (
							<ProtectedRoute isAuthenticated={!!user} redirect="/login" />
						)}
					>
						<Route path="/orders" element={<Orders />} />
						<Route path="/my-account" element={<Account />} />
						<Route path="/user-dashboard/:token?" element={<Dashboard />} />
						<Route path="/payments" element={<PaymentHistory />} />
						<Route path="/wallet" element={isMobile ? <UserWallet /> : <Wallet />} />
						<Route path="/query" element={<Query />} />
						<Route path="/view-order/:orderId?" element={<ViewOrder />} />
						<Route path="/reports" element={<Reports />} />
					</Route>
				
					{/* <Route path="/service" element={<Service />} /> */}
					<Route path="/terms-and-conditions" element={<Terms />} />
					<Route path="/privacy-policy" element={<PrivacyPolicy />} />
					<Route path="/refund-policy" element={<RefundPolicy />} />
					<Route
						path="/admin-login"
						element={
							<PublicRoute>
								<AdminLogin />
							</PublicRoute>
						}
					/>
				
				</Routes>
			) : (
				<Routes>
					<Route path="/" element={<Home />} />
					<Route path="/login" element={isMobile ? <MobileLogin /> : <Login />} />
					<Route path="/payment-status" element={<PaymentStatus />} />
					<Route path="/support" element={<Contact />} />
					<Route path="/leaderboard" element={<Leaderboard />} />
					<Route path="/track-order" element={<TrackOrder />} />
					<Route path="/product/:name?" element={<ProductInfo />} />
					<Route path="/promo/:id?" element={<SinglePromoEvent />} />
					<Route path="/promo" element={<PromoEvents />} />
					<Route path="/announcement" element={<Announcement />} />
					<Route path="/terms-and-conditions" element={<Terms />} />
					<Route path="/privacy-policy" element={<PrivacyPolicy />} />
					<Route path="/refund-policy" element={<RefundPolicy />} />
					<Route path="/admin-login" element={<AdminLogin />} />
					<Route path="/order-status" element={<OrderStatus />} />
					{/* <Route path="*" element={<Maintenance />} /> */}
				</Routes>
			)}
		</BrowserRouter>
	);
}

export default App;
